import { render, staticRenderFns } from "./iDSAbout.vue?vue&type=template&id=04638585"
import script from "./iDSAbout.vue?vue&type=script&lang=js"
export * from "./iDSAbout.vue?vue&type=script&lang=js"
import style0 from "./iDSAbout.vue?vue&type=style&index=0&id=04638585&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports